import { MenuService } from '../../services/menu.service';
import { Component, OnInit,Input } from '@angular/core';
import { IStore } from '../../services/store.service';
import { OrderType } from '../../pages/list-page/list-page.component';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-item-preparation-modal',
    templateUrl: './item-preparation-modal.component.html',
    styleUrls: ['./item-preparation-modal.component.scss'],
    standalone: false
})
export class ItemPreparationModalComponent implements OnInit {
  @Input() orderType: OrderType;
  @Input() menuItem: any;

  selectedOrderDate: string | null = null;
  selectedOrderTime: string | null = null;

  get storeAddress() {

    return `${this.menuService.store.address.streetNumber} ${this.menuService.store.address.street}, ${this.menuService.store.address.city}`;
  }

  constructor(
    private modalController: ModalController,
    public menuService: MenuService,
    public translationService: TranslationService,


    ) { }

  ngOnInit() {  
    if(this.menuService.prepareFollowingDays && this.menuService.prepareFollowingDays.length > 0 
      && this.menuService.prepareFollowingDays[0].key == null
    ) {
      this.menuService.preparationDatePickerChanged(this.orderType, null);
    }
  }

  async continueToItemDetail(){
    let orderDateTime: any = {
      orderDate: this.selectedOrderDate,
      orderTime: this.selectedOrderTime
    }
    await this.modalController.dismiss(orderDateTime);
    await this.menuService.itemDetail(this.menuItem);
  }

}
